import { type ReactNode, useEffect } from "react";
import { useLocation } from "wouter";
import { PageLoader } from "../../components/ui/Spinner";
import { useCurrentUser } from "./useAuth";
import { TermsGate } from "../../components/TermsGate";

interface RequireAuthProps {
  children: ReactNode;
  fallback?: ReactNode;
}

export function RequireAuth({ children, fallback }: RequireAuthProps) {
  const { data: user, isLoading } = useCurrentUser();
  const [, setLocation] = useLocation();

  useEffect(() => {
    if (!isLoading && user === null) {
      setLocation("/login");
    }
  }, [isLoading, user, setLocation]);

  if (isLoading) {
    return fallback ?? <PageLoader />;
  }

  if (user === null) return null;

  // The gate renders itself only while terms are unaccepted, and is not
  // dismissible — so it covers every authenticated page from one place.
  return (
    <>
      <TermsGate />
      {children}
    </>
  );
}
